import React, { useState } from 'react';
import Picture from '../../Picture';

import './TwoColumnAccordionWithImage.scss';

const TwoColumnAccordionWithImage = ({
  mainTitleRegular,
  mainTitleBold,
  titleGraphicSrc,
  titleGraphicAlt,
  features,
  mainImageSrc,
  mainImageAlt,
  isAIPage
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const onItemClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  let currentImageSrc = mainImageSrc;
  let currentImageAlt = mainImageAlt;

  if (activeIndex !== null && features[activeIndex] && features[activeIndex].imageSrc) {
    currentImageSrc = features[activeIndex].imageSrc;
    currentImageAlt = features[activeIndex].imageAlt || features[activeIndex].title || mainImageAlt;
  }

  const MainTitleComponent = isAIPage ? 'h3' : 'h3';
  const FeatureTitleComponent = isAIPage ? 'p' : 'h4';

  return (
    <section className="two-cols-accordion-section container">
      <div className="two-cols-accordion-title-wrapper">
        <MainTitleComponent className="two-cols-accordion-main-title">
          {mainTitleRegular && <span className="two-cols-accordion-title-regular">{mainTitleRegular} </span>}
          {mainTitleBold && <span className="two-cols-accordion-title-bold">{mainTitleBold}</span>}
        </MainTitleComponent>
        {titleGraphicSrc && (
          <Picture
            className="two-cols-accordion-title-graphic"
            alt={titleGraphicAlt || 'Decorative graphic'}
            src={titleGraphicSrc}
          />
        )}
      </div>

      <div className="two-cols-accordion-content-wrapper">
        <div className="two-cols-accordion-features-list">
          {features && features.map((feature, index) => (
            <div
              key={feature.id || index}
              className="two-cols-accordion-feature-item-detailed"
            >
              <div
                className="two-cols-accordion-feature-item-header"
                onClick={() => onItemClick(index)}
                onKeyDown={(e) => e.key === 'Enter' && onItemClick(index)}
                role="button"
                tabIndex={0}
                aria-expanded={activeIndex === index}
                aria-controls={`feature-desc-${feature.id || index}`}
              >
                <div className="two-cols-accordion-feature-icon-title-wrapper">
                  {feature.iconSrc && (
                    <div className="two-cols-accordion-feature-icon-container">
                      <Picture
                        className="two-cols-accordion-feature-icon"
                        alt={feature.iconAlt || 'Feature icon'}
                        src={feature.iconSrc}
                      />
                    </div>
                  )}
                  <FeatureTitleComponent className="two-cols-accordion-feature-item-title">{feature.title}</FeatureTitleComponent>
                </div>
                {feature.arrowSrc && (
                    <Picture
                        className={`two-cols-accordion-feature-arrow ${activeIndex === index ? 'expanded' : ''}`}
                        alt={feature.arrowAlt || 'Ver mais / menos'}
                        src={feature.arrowSrc}
                    />
                )}
              </div>
              {feature.description && (
                <div
                  id={`feature-desc-${feature.id || index}`}
                  className={`two-cols-accordion-feature-item-description ${activeIndex === index ? 'expanded' : ''}`}
                >
                  <p>{feature.description}</p>
                </div>
              )}
              <hr className="two-cols-accordion-feature-item-divider" />
            </div>
          ))}
        </div>

        {currentImageSrc && (
          <div className="two-cols-accordion-image-container">
            <Picture
              className="two-cols-accordion-image"
              alt={currentImageAlt || 'Section image'}
              src={currentImageSrc}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default TwoColumnAccordionWithImage;


// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/custom/TwoColumnAccordionWithImage.jsx